export default __webpack_public_path__ + "static/media/cabine-vaga.0d5347cd.svg";